module.exports = __webpack_public_path__ + "img/Surface_of_Water.b9cbda0a.svg";